<div class="container-fluid sell_dash">
	<div class="wrapper">
		<div class="row">
			<app-sidemenu></app-sidemenu> 
			<section class="right">
				<app-sellheader></app-sellheader>
				<div class="right-middle row justify-content-center">
					<div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12" id="domain">
						<div class="row margin purchase-salient2">
							<div class="ex5 animated animatedFadeInUp fadeInUp">
									<h1 style="font-size: 65px;">Join the Revolution in Workspaces</h1>
									<button class="subscribe-button">Discover More</button>
							</div>		
							<div class="logo">
									<div class="row">
										<div class="col-md-6">
                                          <div class="row">
											  <div class="col-md-4 col-6 image">
												  <img class="image animated animatedFadeInUp fadeInUp" src="../../../assets/image/1-light.png" alt="" >
											  </div>
											  <div class="col-md-4 image">
												<img class="image animated animatedFadeInUp fadeInUp" src="../../../assets/image/1-light.png" alt="" >
											</div>
											<div class="col-md-4 image">
												<img class="image animated animatedFadeInUp fadeInUp" src="../../../assets/image/1-light.png" alt="" >
											</div>
										  </div>
										</div>
										<div class="col-md-6">
											<div class="row">
												<div class="col-md-4 col-6 image">
													<img class="image animated animatedFadeInUp fadeInUp" src="../../../assets/image/1-light.png" alt="" >
												</div>
												<div class="col-md-4 image">
												  <img class="image animated animatedFadeInUp fadeInUp" src="../../../assets/image/1-light.png" alt="" >
											  </div>
											  <div class="col-md-4 image">
												  <img class="image animated animatedFadeInUp fadeInUp" src="../../../assets/image/1-light.png" alt="" >
											  </div>
											</div>
										  </div>
										
									</div>
							</div>
						</div>
					</div>


					<div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12" id="domain">
						<div class="ex2 animated animatedFadeInUp fadeInUp">
							<h1>If you're ready to ditch the dated office cubicle paradigm, we have the solution</h1>
						</div>
					</div>
                    <div class="col-md-10 col-lg-8 col-xl-11 col-10 col-sm-10">
                        <div class="wrapper">
                        <div class="row">
                            <div class="col-sm col-lg-6 col2" >
                                <div class="row">
                                    <div class="col-md-12 col2">
                                    <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
                                    <div class="inner-div" style="background-image: url(assets/image/wolf.jpg);"></div>
                                    <div class="info" style="padding-top: 50%;">
                                        <div class="info_heading">
                                            <h2>Accessories</h2>
                                            <p>Shop Now</p>
                                        </div>
                                         </div>
                                     </div>
                                     </div>
                                </div>
                                
                                <div class="row rowmargin" >
                                    <div class="col-sm col-lg-6 col2" >
                                        <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()" style="height: 200px;">
                                            <div class="inner-div" style="background-image: url(assets/image/parkinggarage.jpg);"></div>
                                            <div class="info" style="padding-top: 20%;">
                                                <div class="info_heading">
                                                    <h2>Hipster Style</h2>
                                                    <p>Shop Now</p>
                                                </div>
                                                 
                                             </div>
                                        </div>
                                    </div>
                                    <div class="col-sm col-lg-6 col2">
                                        <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()" style="height: 200px;">
                                            <div class="inner-div" style="background-image: url(assets/image/office.jpg);"></div>
                                            <div class="info" style="padding-top: 30%;">
                                                <div class="info_heading">
                                                    <h2>Outerwear</h2>
                                                    <p>Shop Now</p>
                                                </div>
                                                 
                                             </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm col-lg-6 col2">
                                <div class="row">
                                    <div class="col-md-12 col2" >
                                        <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()" style="height: 195px;">
                                            <div class="inner-div" style="background-image: url(assets/image/music.jpg);"></div>
                                            <div class="info" style="padding-top: 15%;">
                                                <div class="info_heading">
                                                    <h2>Basic T-Shirts</h2>
                                                    <p>Shop Now</p>
                                                </div>
                                                 
                                             </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row rowmargin">
                                    <div class="col-sm col-lg-6 col2" >
                                        <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()" style="height: 195px;">
                                            <div class="inner-div" style="background-image: url(assets/image/reeboksneakers.jpg);"></div>
                                            <div class="info" style="padding-top: 20%;">
                                                <div class="info_heading">
                                                    <h2>Casual Shirts</h2>
                                                    <p>Shop Now</p>
                                                </div>
                                                 
                                             </div>
                                        </div>
                                    </div>
                                    <div class="col-sm col-lg-6 col2">
                                        <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()" style="height: 195px;">
                                            <div class="inner-div" style="background-image: url(assets/image/sunflower.jpg);"></div>
                                            <div class="info">
                                                <div class="info_heading">
                                                    <h2>Fresh Clothing</h2>
                                                    <p>Shop Now</p>
                                                </div>
                                                 
                                             </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row rowmargin" >
                                    <div class="col-md-12 col2" >
                                        <div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()" style="height: 200px;">
                                            <div class="inner-div" style="background-image: url(assets/image/nature.jpg);"></div>
                                            <div class="info" style="padding-top: 15%;">
                                                <div class="info_heading">
                                                    <h2>Sports Clothing</h2>
                                                    <p>Shop Now</p>
                                                </div>
                                                 
                                             </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                   


					<div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12" >
						<div class="row margin cascade_card" id="cascade">
						<div class="col-md-6">
						<div class="outer-card">
							<div class="inner-card animatable moveUp">
							 </div>
							</div>
						</div>
						<div class="col-md-6 text-col">
							<h1>Refreshingly unique workspace locations</h1>
							<p class="paragraph">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>
							<p class="paragraph">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences</p>
							<p class="paragraph" style="color: #FF5433;">Purchase Salient</p>
						</div>
					</div>

					<div class="row margin" id="cascade">
						<div class="col-md-6 text-col">
							<h1>Luxury amenities come standard in every office</h1>
							<p class="paragraph">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>
							<p class="paragraph">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences</p>
						    <p class="paragraph" style="color: #5694FF;">Sign Up Now</p>
						</div>
						<div class="col-md-6">
						<div class="outer-card2">
							<div class="inner-card2 animatable moveUp">
							 </div>
							</div>
						</div>
					</div>
				</div>
				
				
					<div class="row orange-element">
						<div class="col-md-6 text-col2">
							<h1>Tons of locations worldwide and more on the way</h1>
							<p class="paragraph">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>
							<div class="row">
								<div class="col-md-6 paragraph">
									<ul>
										<li>875+ premium locations available worldwide</li>
										<li>Reservable conference rooms at every office location</li>
										<li>Flexible membership offered for weekly/monthly/yearly</li>
									</ul>
								</div>
								<div class="col-md-6 paragraph">
									<ul>
										<li>875+ premium locations available worldwide</li>
										<li>Reservable conference rooms at every office location</li>
										<li>Flexible membership offered for weekly/monthly/yearly</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-md-6">
						<div class="outer-card3">
							<div class="inner-card3 animatable moveUp">
							 </div>
							</div>
						</div>
					</div>

					<div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12" id="domain">
						<div class="row margin purchase-salient">
							<div class="ex4 animated animatedFadeInUp fadeInUp">
									<h1>If you wish to make an apple pie from scratch, you must first invent the universe.</h1>
									<button class="subscribe-button">Purchase Salient</button>
							</div>
						</div>
					</div>
				</div>
			</section>
	          <!-- begin::Sticky Toolbar -->
		      <app-stickytoolbar></app-stickytoolbar>
              <!-- end::Sticky Toolbar -->     
		</div>
	</div>
</div>